var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37482 6.15035H3.28183V3.1234C3.28183 2.1844 4.05436 1.41844 5.00143 1.41844C5.9485 1.41844 6.71817 2.1844 6.71817 3.1234V4.13617H8.14878V3.1234C8.14878 1.40142 6.73534 0 5.00143 0C3.26752 0 1.85122 1.40142 1.85122 3.1234V6.15035H1.62518C0.726752 6.15035 0 6.87092 0 7.7617V14.3915C0 15.2794 0.726752 16 1.62518 16H8.37482C9.27325 16 10 15.2794 10 14.3915V7.7617C10 6.87092 9.27325 6.15035 8.37482 6.15035ZM5.92275 10.7858C5.80544 10.8965 5.73391 11.044 5.73391 11.2028V13.078C5.73391 13.2567 5.58798 13.4014 5.41059 13.4014H4.59227C4.41202 13.4014 4.26609 13.2567 4.26609 13.078V11.2028C4.26609 11.044 4.19743 10.8965 4.08011 10.7887C3.81974 10.5475 3.65665 10.2014 3.65665 9.81844C3.65665 8.99007 4.41488 8.34326 5.27611 8.51348C5.80544 8.61844 6.2289 9.05248 6.32332 9.58014C6.40629 10.0511 6.23462 10.4908 5.92275 10.7858Z",
    fill: "#FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.50fcc2da74cb824f9fefef654e20cace.svg";
export { ForwardRef as ReactComponent };